// frontend_react/src/pages/AuthCallback.jsx
import React, { useEffect, useContext, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import AuthContext from '../context/AuthContext';

const AuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { login } = useContext(AuthContext);
    const [status, setStatus] = useState('Verifica token in corso...');
    
    // USEREF serve a garantire che la chiamata avvenga una volta sola
    const effectRan = useRef(false);

    useEffect(() => {
        // Se l'effetto ha già girato, fermati subito.
        if (effectRan.current === true) return;

        const verifyToken = async () => {
            const params = new URLSearchParams(location.search);
            const magicToken = params.get('magic_token');

            if (!magicToken) {
                setStatus('Nessun token trovato.');
                return;
            }

            // Segna che abbiamo avviato il processo per non rifarlo
            effectRan.current = true;

            try {
                const response = await axios.get(`/api_verify_token.php?magic_token=${magicToken}`);
                
                if (response.data.success) {
                    login(response.data);
                    setStatus('Accesso riuscito! Reindirizzamento...');
                    setTimeout(() => navigate('/dashboard'), 1500);
                } else {
                    setStatus('Errore: ' + response.data.message);
                }
            } catch (error) {
                console.error("Errore verifica:", error);
                // Gestiamo il caso in cui il token è stato appena consumato dalla "prima" chiamata fantasma
                if (error.response && error.response.status === 401) {
                    setStatus('Link scaduto o già utilizzato. Prova a richiedere un nuovo accesso.');
                } else {
                    setStatus('Errore di connessione.');
                }
            }
        };

        verifyToken();
        
        // Funzione di cleanup (opzionale, ma buona pratica in React 18)
        return () => {
            effectRan.current = true;
        };
    }, [location, login, navigate]);

    return (
        <div className="container mt-5 text-center">
            <h3>{status}</h3>
            {status.includes('corso') && (
                <div className="spinner-border mt-3 text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            )}
        </div>
    );
};

export default AuthCallback;